import { useMemo, useState } from 'react';

export const ALL_CHIP = 'Tutti';

export function useFuelFilter<T>(
	items: T[],
	fuelOf: (item: T) => string | null | undefined
) {
	const chips = useMemo(() => {
		const present = new Set<string>();
		for (const item of items) {
			const value = fuelOf(item)?.trim();
			if (value) present.add(value);
		}
		return [ALL_CHIP, ...[...present].sort((a, b) => a.localeCompare(b))];
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [items]);

	const [activeChip, setActiveChip] = useState<string>(ALL_CHIP);
	const effectiveChip = chips.includes(activeChip) ? activeChip : ALL_CHIP;

	const filtered = useMemo(
		() =>
			effectiveChip === ALL_CHIP
				? items
				: items.filter((item) => fuelOf(item)?.trim() === effectiveChip),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[items, effectiveChip]
	);

	return { chips, activeChip: effectiveChip, setActiveChip, filtered };
}
